export const imgLocation = require("../assets/location.png");
export const imgLogo = require("../assets/logo.png");
